import type { TestContext } from 'yup';

export function flowValidation(this: TestContext, value: (string | number)[]) {
  if (value.length > 1 && value.includes('not_assigned')) {
    return this.createError({ message: "Rule can't have not assigned and other flow at one time" });
  }

  return true;
}
